export const STORE_SERVICES = {
    CURBSIDE_PICKUP: 9,
};
